export default {
    plugins: {
        textRun:'Text run',
        customPlugin: 'Custom Plugins',
        create: 'Create',
        HowToCreate: 'How to create',
        builtinPlugin: 'Built-in Plugins',
        contributePlugin: 'Contribute Plugin',
        pluginConfig: 'Plugin',
        pluginDescription: 'Description',
        pluginIntroduction: 'Introduction',
        confirmDelete: 'Are you sure you want to delete?',
        pluginName: 'Plugin Name',
        PleasePluginName: 'Enter the plugin name',
        Name: 'Name',
        Description: 'Description',
        pluginDescriptionTip: 'The plugin description is used for decision-making regarding the plugin. Please clearly describe the usage scenarios for the plugin, specifically under what circumstances the plugin should be executed.',
        PleasePluginDescription: 'Enter the plugin description',
        Avatar: 'Avatar',
        requestUrl: 'Plugin URL',
        requestType: 'Request Type',
        requestAddress: 'Enter the request address.',
        requestParameters: 'Parameters',
        requiredField: 'Required',
        isParameterRequired: 'Is this parameter required when making the request?',
        parameterName: 'Parameter Name',
        PleaseInputParameterName: 'Enter parameter name',
        parameterType: 'Parameter Type',
        parameterDescription: 'Description',
        parameterDescriptionTip: 'The description is the meaning of the parameter, which will be used to extract parameters from user input based on this description. For example: the parameter name is "phone", and the description is "Please enter the mobile number of the sender or recipient."',
        PleaseInputParameterDescription: 'Enter description',
        default: 'Default Value',
        defaultTip: 'The default value to use when the parameter is not extracted from user input, optional',
        defaultInput: 'Parameter default value, optional',
        addSubParameter: 'Add sub-parameter',
        pleaseInputValue: 'Please input value',
        addParameter: 'Add parameter',
        responseResult: 'Response',
        responseResultTip: 'Fill in the field name and description of the interface response to help the model better understand the response data. You can automatically fill in the actual interface return data.',
        autoFill: 'Auto Fill',
        array: 'Array',
        PleaseInputParameter: 'Please input parameter',
        responseParameters: 'Response Parameters',
        noRequestParameters: 'No request parameters',
        statusCode: 'Status Code ',
        reParse: 'Re-parse',
        parse: 'Parse',
        debug: 'Test Run',
        noRequestParametersTip: 'No request parameters, you can click to run directly',
        run: 'Run',
        debugTip: 'Click the "Run" button to test execute',
        prarameterTypeStr: {
            str: 'String',
            int: 'Integer',
            float: 'Float',
            bool: 'Boolean',
            object: 'Object',
            Array: 'Array',
        },
        deleteAllNode: 'Delete all nodes under this root node, are you sure to delete?',
        deleteNode: 'Delete node',
        pleaseFillRequestParameters: 'Please fill in the request parameters',
        parameterNameRepeat: 'Parameter name repeated',
        parameterNameSupport: 'Parameter name only supports English letters and underscores "_"',
        pleaseSelectRequestType: 'Please select request type',
        pleaseInputRequestAddress: 'Please input request address',
        pleaseInputRequestParameters: 'Please input request parameters',
        validatePar: {
            pleaseInputPluginName: 'Please input plugin name',
            pleaseInputPluginDescription: 'Please input plugin description',
            pleaseUploadPluginImage: 'Please upload plugin image',
            pleaseSelectRequestType: 'Please select request type',
            pleaseInputRequestAddress: 'Please input request address',
            pleaseInputRequestParameters: 'Please input request parameters',
        },
        createSuccess: 'Create success',
    },
}
